import openPopup from "../popup.js";

// TODO Рендер отзывов при открытии попапа с отзывами
const dataReviews = [
    {
        id: 1,
        author: REVIEWS[0].author,
        date: REVIEWS[0].date,
        text: REVIEWS[0].text,
        rating: "../../assets/img/reviews/5_stars.svg",
        ratingNumber: "5.0",
    },
    {
        id: 2,
        author: REVIEWS[1].author,
        date: REVIEWS[1].date,
        text: REVIEWS[1].text,
        rating: "../../assets/img/reviews/5_stars.svg",
        ratingNumber: "5.0",
    },
    {
        id: 3,
        author: REVIEWS[2].author,
        date: REVIEWS[2].date,
        text: REVIEWS[2].text,
        rating: "../../assets/img/reviews/5_stars.svg",
        ratingNumber: "5.0",
    },
    {
        id: 4,
        author: REVIEWS[3].author,
        date: REVIEWS[3].date,
        text: REVIEWS[3].text,
        rating: "../../assets/img/reviews/4_stars.svg",
        ratingNumber: "4.0",
    },
    {
        id: 5,
        author: REVIEWS[4].author,
        date: REVIEWS[4].date,
        text: REVIEWS[4].text,
        rating: "../../assets/img/reviews/5_stars.svg",
        ratingNumber: "5.0",
    },
    {
        id: 6,
        author: REVIEWS[5].author,
        date: REVIEWS[5].date,
        text: REVIEWS[5].text,
        rating: "../../assets/img/reviews/5_stars.svg",
        ratingNumber: "5.0",
    },
    {
        id: 7,
        author: REVIEWS[6].author,
        date: REVIEWS[6].date,
        text: REVIEWS[6].text,
        rating: "../../assets/img/reviews/5_stars.svg",
        ratingNumber: "5.0",
    },
    {
        id: 8,
        author: REVIEWS[7].author,
        date: REVIEWS[7].date,
        text: REVIEWS[7].text,
        rating: "../../assets/img/reviews/4_stars.svg",
        ratingNumber: "4.0",
    },
    {
        id: 9,
        author: REVIEWS[8].author,
        date: REVIEWS[8].date,
        text: REVIEWS[8].text,
        rating: "../../assets/img/reviews/5_stars.svg",
        ratingNumber: "5.0",
    },
    {
        id: 10,
        author: REVIEWS[9].author,
        date: REVIEWS[9].date,
        text: REVIEWS[9].text,
        rating: "../../assets/img/reviews/5_stars.svg",
        ratingNumber: "5.0",
    },
    {
        id: 11,
        author: REVIEWS[10].author,
        date: REVIEWS[10].date,
        text: REVIEWS[10].text,
        rating: "../../assets/img/reviews/5_stars.svg",
        ratingNumber: "5.0",
    },
    {
        id: 12,
        author: REVIEWS[11].author,
        date: REVIEWS[11].date,
        text: REVIEWS[11].text,
        rating: "../../assets/img/reviews/5_stars.svg",
        ratingNumber: "5.0",
    },
];

const reviewOpen = document.querySelectorAll(".review .more");

const authorRev = document.querySelector(".popup-review .author__name");
const dateRev = document.querySelector(".popup-review time");
const textRev = document.querySelector(".popup-review .text");
const imgRev = document.querySelector(".popup-review .info img");
const rateNumberRev = document.querySelector(".popup-review .info .num");

reviewOpen.forEach(more => {
    more.addEventListener("click", function () {
        let attrRev = Number(more.getAttribute("data-id"));
        let currentRev = dataReviews.find(rev => rev.id === attrRev);

        let { author, date, text, rating, ratingNumber } = currentRev;
        authorRev.innerHTML = author;
        dateRev.innerHTML = date;
        textRev.innerHTML = text;
        imgRev.src = rating;
        rateNumberRev.innerHTML = ratingNumber;
    });
});

new openPopup({
    selector: "#popup-review",
    elOpen: ".review .more",
    elClose: "#popup-review .ui-close",
    overlay: "#popup-review .popup-overlay",
});
